module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 99.754c0e44.png";